<div #trigger="cdkOverlayOrigin" class="flex flex-row cursor-pointer" cdkOverlayOrigin>
  <app-new-button
    [type]="'secondary'"
    [size]="'responsive'"
    [backgroundMode]="'light'"
    (click)="openClick($event)"
  >
    <span>{{ buildTranslationKey('buttons.' + buttonTranslationKey) | translate }}</span>
  </app-new-button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="close()"
  >
    <div [class.hidden]="hidden">
      <ng-container *ngTemplateOutlet="openableTemplate; context: context"></ng-container>
    </div>
  </ng-template>
</div>
